import { SortDirection } from '../types';
export function getNextSortState({ sortState, columnId }) {
    const isColumnSame = sortState.columnId === columnId;
    const isDefaultDirection = sortState.direction === SortDirection.ascending;
    let newSortDirection = SortDirection.ascending;
    if (isColumnSame && isDefaultDirection) {
        newSortDirection = SortDirection.descending;
    }
    return { columnId, direction: newSortDirection };
}
//# sourceMappingURL=getNextSortState.js.map